import { useToastStore } from '@/stores/toast'

export function useToast() {
    const toastStore = useToastStore()

    return {
        showSuccess: (message: string, description?: string, duration?: number) => {
            return toastStore.showSuccess(message, description, duration)
        },
        showError: (message: string, description?: string, duration?: number) => {
            console.error('❌ Error:', message)
            return toastStore.showError(message, description, duration)
        },
        showInfo: (message: string, description?: string, duration?: number) => {
            return toastStore.showInfo(message, description, duration)
        },
        showWarning: (message: string, description?: string, duration?: number) => {
            console.warn('⚠️ Warning:', message)
            return toastStore.showWarning(message, description, duration)
        }
    }
}
